import React from "react"
import { Slot } from "@radix-ui/react-slot"

import { TSocialMediaLink } from "@/types/app"
import { cn } from "@/lib/utils"
import { Link } from "@/components/ui/atoms"
import { TNavItem } from "@/components/ui/organisms"

export interface FooterBottomProps extends React.HTMLAttributes<HTMLDivElement> {
  asChild?: boolean
  links: TNavItem[]
  socialMediaLinks: TSocialMediaLink[]
}

const FooterBottom = React.forwardRef<HTMLDivElement, FooterBottomProps>(
  ({ className, asChild = false, socialMediaLinks, links, ...props }, ref) => {
    const Component = asChild ? Slot : "span"
    return (
      <Component
        className={cn(
          "flex flex-col items-center justify-between bg-neutral-100 py-5 md:py-8 xl:flex-row",
          className
        )}
        ref={ref}
        {...props}
      >
        <div className="mb-7 flex justify-start xl:my-0">
          {socialMediaLinks.map((link) => {
            return (
              <Link
                key={link.href}
                chapters={["Footer", link.title]}
                title={link.title}
                href={link.href}
                variant="primary"
                className="mr-5"
                iconLeft={link.iconLeft}
                target={"_blank"}
              />
            )
          })}
        </div>
        <div className="mr-7 flex shrink-0 flex-col items-center md:mt-0 lg:flex-row xl:mr-0">
          {links.map((link) => {
            return (
              <Link
                chapters={["Footer", link.title]}
                key={link.codename}
                href={link.href}
                variant="ghost"
                className="label-s label-s--link mb-6 ml-7 block p-0 text-neutral-400 lg:mb-0"
                id={link.codename}
              >
                {link.title}
              </Link>
            )
          })}
        </div>
      </Component>
    )
  }
)
FooterBottom.displayName = "FooterBottom"

export default FooterBottom
